import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withKeys as _withKeys, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f1efcfe"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onKeydown"]

import { onMounted, onUnmounted, ref } from 'vue';

export type Props = {
  value: string | number,
  pressInterval?: number,
  isCancelHold?: boolean,
  isGlobalKeyHandler?: boolean
}
export type Emits = {
  (e: 'key-pressed', keyValue: Props['value']): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseKey',
  props: {
    value: null,
    pressInterval: { default: 100 },
    isCancelHold: { type: Boolean, default: false },
    isGlobalKeyHandler: { type: Boolean, default: false }
  },
  emits: ["key-pressed"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'key-pressed', keyValue: Props['value']): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: string | number, pressInterval: number, isCancelHold: boolean, isGlobalKeyHandler: boolean };




const intervalID = ref<number>(0);
const buttonEl = ref<HTMLButtonElement | null>(null);

onMounted(() => {
  if (props.isGlobalKeyHandler) {
    document.addEventListener('keydown', onValueKey.bind(this));
  }
});

onUnmounted(() => {
  document.removeEventListener('keydown', onValueKey);
});

/**
 * After holding the key for long enough, a continuous stream of the key's value is emitted.
 * This stream can be cancelled externally.
 */
function onHold() {
  intervalID.value = window.setInterval(() => {
    if (props.isCancelHold) {
      clearInterval(intervalID.value);
      intervalID.value = 0;
    } else {
      emit('key-pressed', props.value);
    }
  }, props.pressInterval);
}

/**
 * On key press whithout holding, it emits the character. If it's the end of a long hold, it stops the value's stream.
 */
function onRelease() {
  if (intervalID.value) {
    clearInterval(intervalID.value);
    intervalID.value = 0;
  } else {
    emit('key-pressed', props.value);
  }
}

/** 
 * Programatically clicks on the button after pressing precisely the keyboard key this component represents.
 * @param event - DOM event for keyboard stroke.
 */
function onValueKey(event: KeyboardEvent) {
  if (event.key === props.value.toString() && !buttonEl.value?.disabled) {
    onRelease();
    buttonEl.value?.focus();
  }
}

return (_ctx: any,_cache: any) => {
  const _directive_touch = _resolveDirective("touch")!

  return _withDirectives((_openBlock(), _createElementBlock("button", {
    ref_key: "buttonEl",
    ref: buttonEl,
    class: "base-key",
    type: "button",
    onKeydown: _withKeys(onRelease, ["enter","space"])
  }, [
    _createTextVNode(_toDisplayString(__props.value), 1)
  ], 40, _hoisted_1)), [
    [_directive_touch, onHold, "hold"],
    [_directive_touch, onRelease, "release"]
  ])
}
}

})